import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Mixpanel from 'utils/mixpanelService';
import { makeSelectAuth } from 'containers/Auth/selectors';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import { getClientLogo, getClientUrl, getCMClientLogo } from '../utils';

const useStyles = makeStyles(theme => ({
  verticalDivider: {
    borderRight: '1px solid #E3E3E3',
    height: 30,
    margin: '0 10px',
  },
  clientLogo: {
    maxHeight: 45,
    [theme.breakpoints.down('435')]: {
      maxHeight: 40,
    },
    [theme.breakpoints.down('410')]: {
      maxHeight: 35,
    },
    [theme.breakpoints.down('330')]: {
      maxHeight: 30,
    },
  },
  byLabel: {
    color: theme.palette.text.primary,
    margin: 0,
    ...theme.typography.pxSmall,
  },
  link: {
    textDecoration: 'none',
  },
}));

const redirect = (url, auth, location) => {
  Mixpanel.track('Source Exit - Clicked', {
    page: location.pathname,
    exitPage: url,
    component: 'NavBar',
  });
};

function ClientLogo({ clientDetails, isDialog, isClientPage }) {
  const location = useLocation();
  const classes = useStyles();
  const auth = useSelector(makeSelectAuth());
  const clientLogo = getClientLogo(clientDetails);
  const clientUrl = getClientUrl(clientDetails);
  const hasCMLogo = !_isEmpty(getCMClientLogo(clientDetails));
  if (_isEmpty(clientLogo)) return null;
  return (
    <>
      {!isDialog && !isClientPage && hasCMLogo && (
        <div className={classes.verticalDivider} />
      )}

      <a
        href={clientUrl}
        target="_blank"
        rel="noopener"
        className={classes.link}
        onClick={() => redirect(clientUrl, auth, location)}
      >
        <img
          src={clientLogo}
          alt="Co-brand Logo"
          className={classes.clientLogo}
        />
        {!hasCMLogo && !isClientPage && (
          <p className={classes.byLabel}>By CredibleMind</p>
        )}
      </a>
    </>
  );
}

ClientLogo.propTypes = {
  clientDetails: PropTypes.object,
  isDialog: PropTypes.bool,
  isClientPage: PropTypes.bool,
};

export default ClientLogo;
